module.exports = __webpack_public_path__ + "img/icon-trophy.bc53469e.svg";